'use strict';

export const systemStyles = [
	{
		class: 'hint',
		name: 'Small Text',
		tags: ['literal'],
	},
	{
		class: 'mx-sb-label',
		name: 'Label',
		tags: ['literal'],
	},
	{
		class: 'mainMessage',
		name: 'Main Message',
		tags: ['literal'],
	},
	{
		class: 'mx-sb-headline',
		name: 'Headline',
		tags: ['literal'],
	},
	{
		class: 'mx-sb-headline-larger',
		name: 'Headline Larger',
		tags: ['literal'],
	},
	{
		class: 'mx-sb-title-hint',
		name: 'Title Hint',
		tags: ['literal'],
	},
	{
		class: 'mx-sb-title',
		name: 'Title',
		tags: ['literal'],
	},
	{
		class: 'mx-sb-subhead',
		name: 'Sub header',
		tags: ['literal'],
	},
	{
		class: 'mx-sb-warning',
		name: 'Warning',
		tags: ['literal'],
	},
	{
		class: 'incident-status',
		name: 'Incident status container',
		tags: ['div'],
	},
	{
		class: 'mx-sb-border',
		name: 'Bordered Block',
		tags: ['div', 'image'],
	},
	{
		class: 'mx-sb-border-active',
		name: 'Active Bordered Block',
		tags: ['div', 'image'],
	},
	{
		class: 'mx-sb-fade-bottom',
		name: 'Faded Bottom',
		tags: ['div', 'image'],
	},
	{
		class: 'mx-sb-image-center-cover',
		name: 'Center and Cover',
		tags: ['image'],
	},
	{
		class: 'mx-sb-no-padding',
		name: 'Reduce containers margins',
		tags: ['div'],
	},
	{
		class: 'mx-sb-table-cell',
		name: 'Table Cell',
		tags: ['div'],
	},
	{
		class: 'mx-sb-button mx-sb-button--active',
		name: 'Active Button',
		tags: ['button', 'link'],
	},
	{
		class: 'mx-sb-button',
		name: 'Button',
		tags: ['button', 'link'],
	},
	{
		class: 'mx-sb-content-color-link',
		name: 'Content colour 1-line Link',
		tags: ['literal'],
	},
	{
		class: 'mx-sb-quick-link-kb-preview',
		name: 'Quick Link for KB Preview',
		tags: ['button'],
	},
	{
		class: 'mx-sb-quick-link-card',
		name: 'Quick Link as Card',
		tags: ['button'],
	},
	{
		class: 'mx-sb-quick-link-title',
		name: 'Quick Link as Title',
		tags: ['button'],
	},
	{
		class: 'mx-sb-code',
		name: 'Input controls code style',
		tags: ['input'],
	},
	{
		class: 'mx-sb-big-quick-link-without-description',
		name: 'Big Quick Link without description',
		tags: ['button'],
	},
	{
		class: 'mx-sb-quick-link-1-line-title',
		name: 'Quick Link just with 1-line title',
		tags: ['button'],
	},
	{
		class: 'mx-sb-monotextline',
		name: 'MonoTextLine',
		tags: ['literal'],
	},
	{
		class: 'mx-sb-chip',
		name: 'Chip',
		tags: ['literal'],
	},
	{
		class: 'mx-sb-3lines',
		name: 'Text: 3 lines max',
		tags: ['literal'],
	},
];
